import React, { useState, useCallback } from "react";
import { useParams, Link } from "react-router-dom";
import "./info.scss";
import "./detail.scss";
import Table from "../../components/Table/Table";
import {
  formatAddress,
  formatNumberWithCommas,
  netWorkName,
  toPlainString,
} from "../../utils/utils";
import { useLazyQuery } from "@apollo/client";
import {
  GET_LIQUIDITY_TVL,
  GET_TRADE_VOLUME,
  GET_POOL_NET_VALUE,
  GET_LIQUIDITY_TOKEN,
  GET_MARGIN_TOKEN,
  GET_LIQUIDITY_DETAILS,
  GET_TRADE_DETAILS,
} from "../../state/graphql/gql";
import AreaChart from "../../components/AreaChart/AreaChart";
import Filter from "./Filter";
import BarChart from "../../components/BarChart/BarChart";
import PieChart from "../../components/PieChart/PieChart";
import dateFormat from "dateformat";
const symbolConfig: {
  [key: string]: { displayName: string };
} = require("../../symbol.json");
export default function Detail() {
  const [getliquidityTvl] = useLazyQuery(GET_LIQUIDITY_TVL, {
    fetchPolicy: "no-cache",
  });
  const [getPoolNetValue] = useLazyQuery(GET_POOL_NET_VALUE, {
    fetchPolicy: "no-cache",
  });
  const [getTradeVolume] = useLazyQuery(GET_TRADE_VOLUME, {
    fetchPolicy: "no-cache",
  });
  const [getLiquidityTokenValue] = useLazyQuery(GET_LIQUIDITY_TOKEN, {
    fetchPolicy: "no-cache",
  });
  const [getMarginTokenValue] = useLazyQuery(GET_MARGIN_TOKEN, {
    fetchPolicy: "no-cache",
  });
  const [getLiquidityDetails] = useLazyQuery(GET_LIQUIDITY_DETAILS, {
    fetchPolicy: "no-cache",
  });
  const [getTradeDetails] = useLazyQuery(GET_TRADE_DETAILS, {
    fetchPolicy: "no-cache",
  });
  const [volumeDay, setVolumeDay] = useState("7D");
  const [netValueDay, setNetValueDay] = useState("7D");
  const [tokenType, setTokenType] = useState("LP");
  const onCopy = useCallback((text: string) => {
    if (text) {
      navigator.clipboard.writeText(text!);
    }
  }, [])
  const tradeColums = [
    {
      title: "DIRECTION",
      dataIndex: "direction",
      key: "direction",
      width: "12.5%",
      render: (value: any) => (
        <span className={`direction ${value}`}>{value?.toUpperCase()}</span>
      ),
    },
    {
      title: "ACCOUNT",
      dataIndex: "account",
      key: "account",
      width: "12.5%",
      render: (value: any) => (value ? <span onClick={() => { onCopy(value) }}>{formatAddress(value)}</span> : ""),
    },
    {
      title: "CHAIN",
      dataIndex: "chainId",
      key: "chainId",
      width: "12.5%",

      render: (value: any) => (value ? netWorkName(value) : ""),
    },
    {
      title: "SYMBOL",
      dataIndex: "symbol",
      key: "symbol",
      width: "12.5%",
      render: (value: string) =>
        (symbolConfig[value] && symbolConfig[value].displayName) || value,
    },
    {
      title: "PRICE",
      dataIndex: "price",
      key: "price",
      width: "12.5%",
      render: (value: any) => formatNumberWithCommas(value),
    },
    {
      title: "VOLUME",
      dataIndex: "volume",
      key: "volume",
      width: "12.5%",
      render: (value: any) => toPlainString(value),
    },
    {
      title: "NOTIONAL",
      dataIndex: "notional",
      key: "notional",
      width: "12.5%",
      render: (value: any) =>
        `$ ${formatNumberWithCommas(Number(Number(value).toFixed(2)))}`,
    },
    {
      title: "TIMESTAMP (UTC)",
      dataIndex: "timestamp",
      key: "timestamp",
      width: "12.5%",
      render: (value: any) =>
        dateFormat(
          new Date(value * 1000).toUTCString(),
          "UTC:yyyy-mm-dd HH:MM:ss"
        ),
    },
  ];
  const liqColums = [
    {
      title: "ACTION",
      dataIndex: "action",
      key: "action",
      width: "16.6%",
      render: (value: any) => (
        <span className={`action ${value}`}>{value?.toUpperCase()}</span>
      ),
    },
    {
      title: "ACCOUNT",
      dataIndex: "account",
      key: "account",
      width: "16.6%",
      render: (value: any) => (value ? <span onClick={() => { onCopy(value) }}>{formatAddress(value)}</span> : ""),
    },
    {
      title: "CHAIN",
      dataIndex: "chainId",
      key: "chainId",
      width: "16.6%",
      render: (value: any) => (value ? netWorkName(value) : ""),
    },
    {
      title: "LIQUIDITY",
      dataIndex: "liquidity",
      key: "liquidity",
      width: "16.6%",
      render: (value: any, row: any) =>
        row.amount > 10 ** 12
          ? "MAX_VALUE"
          : `$ ${formatNumberWithCommas(Number(Number(value).toFixed(4)))}`,
    },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      key: "amount",
      width: "16.6%",
      render: (value: any, row: any) =>
        +row.amount > 10 ** 12
          ? "MAX_VALUE"
          : ` ${formatNumberWithCommas(Number(Number(value).toFixed(6)))} ${row?.assetSymbol
          }`,
    },
    {
      title: "TIMESTAMP (UTC)",
      dataIndex: "timestamp",
      key: "timestamp",
      width: "16.6%",
      render: (value: any) => {
        const now = new Date(value * 1000).toUTCString();
        if (value === 1692384547) {
          console.log(now);
          console.log(dateFormat(now, "UTC:yyyy-mm-dd HH:MM:ss"));
        }
        return dateFormat(now, "UTC:yyyy-mm-dd HH:MM:ss");
      },
    },
  ];
  const getLiquidity = useCallback(async () => {
    let data = [];
    let queryResult = await getliquidityTvl();
    if (
      queryResult?.data &&
      queryResult?.data?.liquidityStatistics &&
      Array.isArray(queryResult?.data?.liquidityStatistics)
    ) {
      data = queryResult?.data?.liquidityStatistics;
    }
    return {
      data: data,
    };
  }, [getliquidityTvl]);
  const getTradeVolumeParam = useCallback(async () => {
    const currentDate = new Date().getTime();
    let param: any = {};
    if (volumeDay !== "ALL") {
      const day = parseInt(volumeDay);
      const thirtyDaysAgoTimestamp = parseInt(
        String((currentDate - day * 24 * 60 * 60 * 1000) / 1000)
      );
      param = {
        variables: {
          fromTimestamp: thirtyDaysAgoTimestamp,
        },
      }
    } else {
      param = {
        variables: {
          fromTimestamp: 0,
        },
      }
    }
    let data = [];
    let queryResult = await getTradeVolume(param);
    if (
      queryResult?.data &&
      queryResult?.data?.volumeStatistics &&
      Array.isArray(queryResult?.data?.volumeStatistics)
    ) {
      data = queryResult?.data?.volumeStatistics;
    }
    return {
      data: data,
    };
  }, [getTradeVolume, volumeDay]);

  const getNetValue = useCallback(async () => {
    let data = [];
    let param: any = {};
    if (netValueDay !== "ALL") {
      const currentDate = new Date().getTime();
      const day = parseInt(netValueDay);
      const thirtyDaysAgoTimestamp = parseInt(
        String((currentDate - day * 24 * 60 * 60 * 1000) / 1000)
      );
      param = {
        variables: {
          fromTimestamp: thirtyDaysAgoTimestamp,
        },
      };
    } else {
      param = {
        variables: {
          fromTimestamp: 0,
        },
      }
    }
    let queryResult = await getPoolNetValue(param);
    if (
      queryResult?.data &&
      queryResult?.data?.lpNetValueStatistics &&
      Array.isArray(queryResult?.data?.lpNetValueStatistics)
    ) {
      data = queryResult?.data?.lpNetValueStatistics;
    }
    return {
      data: data,
    };
  }, [getPoolNetValue, netValueDay]);

  const getToken = useCallback(async () => {
    const getTokenValue =
      tokenType === "LP" ? getLiquidityTokenValue : getMarginTokenValue;
    let data = [];
    let queryResult = await getTokenValue();
    if (
      queryResult?.data &&
      queryResult?.data?.tokenValue &&
      Array.isArray(queryResult?.data?.tokenValue)
    ) {
      data = queryResult?.data?.tokenValue;
    }
    return {
      data: data,
    };
  }, [getLiquidityTokenValue, getMarginTokenValue, tokenType]);

  const getTrade = useCallback(
    async ({ limit = 50, offset = 0 }: { limit?: number; offset?: number }) => {
      let data = [];
      let conut = 0;
      let queryResult = await getTradeDetails({
        variables: {
          limit: limit,
          offset: offset,
        },
      });
      if (
        queryResult?.data &&
        queryResult?.data?.tradeDetails &&
        Array.isArray(queryResult?.data?.tradeDetails)
      ) {
        data = queryResult?.data?.tradeDetails;
        const filteredTrades = data.filter((trade: any) => {
          const btcusdMatch = trade.symbol.match(/BTCUSD-(\d+)-[CP]/);
          const ethusdMatch = trade.symbol.match(/ETHUSD-(\d+)-[CP]/);
          if (btcusdMatch && (parseInt(btcusdMatch[1]) <= 20000)) {
            return false; // 过滤掉符合条件的 BTCUSD 对象
          }

          if (ethusdMatch && (parseInt(ethusdMatch[1]) <= 1000)) {
            return false; // 过滤掉符合条件的 ETHUSD 对象
          }
          return true;
        });
        data = filteredTrades
        conut = queryResult?.data?.tradeDetails[0]?.totalCount;
      }
      return {
        data: data,
        count: conut,
      };
    },
    [getTradeDetails]
  );

  const getLiquidityDetalisParam = useCallback(
    async ({ limit = 50, offset = 0 }: { limit?: number; offset?: number }) => {
      let data = [];
      let conut = 0;
      let queryResult = await getLiquidityDetails({
        variables: {
          limit: limit,
          offset: offset,
        },
      });
      if (
        queryResult?.data &&
        queryResult?.data?.liquidityDetails &&
        Array.isArray(queryResult?.data?.liquidityDetails)
      ) {
        data = queryResult?.data?.liquidityDetails;
        conut = queryResult?.data?.liquidityDetails[0]?.totalCount;
      }
      return {
        data: data,
        count: conut,
      };
    },
    [getLiquidityDetails]
  );

  return (
    <div className="info-main info-detail">
      <div className="title">Deri Analytics</div>
      <div className="charts">
        <div className="graph tvl">
          <AreaChart getData={getLiquidity} title="TVL" />
        </div>
        <div className="graph volume24">
          <Filter defaultValue="7D" onChange={setVolumeDay} cycleArr={["7D", "30D", "ALL"]} />
          <BarChart title="Volume 24H" getData={getTradeVolumeParam} />
        </div>
      </div>
      <div className="charts">
        <div className="graph netValue">
          <Filter defaultValue="7D" onChange={setNetValueDay} cycleArr={["7D", "30D", "ALL"]} />
          <AreaChart
            getData={getNetValue}
            title="LP Net Value"
            decimalScale={4}
            domain={true}
          />
        </div>
        <div className="graph tokens">
          <Filter onChange={setTokenType} cycleArr={["TRADER", "LP"]} />
          <PieChart title="Top Margin/Liquidity" getData={getToken} />
        </div>
      </div>
      <div className="list-by-chain">
        <Table
          title="LIQUIDITY"
          columns={liqColums}
          pagination
          getData={getLiquidityDetalisParam}
        />
        <Table
          title="TRADE"
          columns={tradeColums}
          pagination
          getData={getTrade}
        />
      </div>
    </div>
  );
}
